import { QueryEntity } from '@datorama/akita';
import { switchMap } from 'rxjs/operators';
import { BulkChangeBillingState, getBulkChangeBillingStore } from './bulk-change-billing.store';
import { BulkChangeBillingRun } from './bulk-change-billing.model';

export class BulkChangeBillingQuery extends QueryEntity<BulkChangeBillingState> {
  filters = this.select(({ ui }) => ui);

  pagination = this.select(({ pagination }) => pagination);

  runs = this.filters.pipe(
    switchMap(ui =>
      this.selectAll({
        filterBy: [
          (r: BulkChangeBillingRun) =>
            !ui.corporateAccountId || r.corporateAccountId === ui.corporateAccountId,
          (r: BulkChangeBillingRun) => !ui.status || r.status === ui.status,
          (r: BulkChangeBillingRun) => !ui.propertyId || r.propertyId === ui.propertyId,
        ],
        sortBy: (a, b) =>
          (b.createdAt ? Date.parse(b.createdAt) : 0) - (a.createdAt ? Date.parse(a.createdAt) : 0),
      })
    )
  );

  activeRun = this.selectActive();

  preview = this.select(({ preview }) => preview);

  pendingRunId = this.select(({ pendingRunId }) => pendingRunId);
}

let _bulkChangeBillingQuery: BulkChangeBillingQuery;

export function getBulkChangeBillingQuery(): BulkChangeBillingQuery {
  if (!_bulkChangeBillingQuery) {
    _bulkChangeBillingQuery = new BulkChangeBillingQuery(getBulkChangeBillingStore());
  }
  return _bulkChangeBillingQuery;
}
